"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _styling = require("../../../toolkit/styling");

var _providers = require("../../../toolkit/providers");

var _FixtureCell = _interopRequireDefault(require("./FixtureCell"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FixtureRow = function FixtureRow(props) {
  var styles = useStylesheet(props);
  var style = props.style,
      className = props.className,
      columnCount = props.columnCount,
      childrenProp = props.children,
      cellPadding = props.cellPadding,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["style", "className", "columnCount", "children", "cellPadding"]);
  var children = (0, _react.useMemo)(function () {
    return _react["default"].Children.toArray(childrenProp).filter(function (e) {
      return /*#__PURE__*/_react["default"].isValidElement(e) && e.type.name == _FixtureCell["default"].name;
    });
  }, [childrenProp]);
  return /*#__PURE__*/_react["default"].createElement("tr", (0, _extends2["default"])({}, otherProps, {
    className: (0, _styling.css)(className, styles.root, style)
  }), children.map(function (child) {
    if (! /*#__PURE__*/_react["default"].isValidElement(child)) {
      return null;
    }

    return /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
      columnCount: columnCount,
      className: (0, _styling.css)(styles.fixtureCell, child.props.className, {
        padding: child.props.spanEntireRow ? 0 : null
      })
    }));
  }));
};

var _default = FixtureRow;
exports["default"] = _default;

var useStylesheet = function useStylesheet(_ref) {
  var cellPadding = _ref.cellPadding;

  var _useTheme = (0, _providers.useTheme)(),
      borderPrimary = _useTheme.borderPrimary,
      surfaceLightest = _useTheme.surfaceLightest;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        backgroundColor: surfaceLightest,
        borderTop: "1px solid ".concat(borderPrimary)
      },
      fixtureCell: {
        border: "none",
        padding: cellPadding,
        whiteSpace: "nowrap",
        "first-child": {
          paddingLeft: 14
        },
        backgroundColor: surfaceLightest
      }
    });
  }, [cellPadding, borderPrimary, surfaceLightest]);
};